export default __webpack_public_path__ + "static/media/diverse-team.27b08e82.svg";